import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  private key = 'mtslive';

  encrypt(value: any): string {

    let encrypted = CryptoJS.AES.encrypt(value.toString(), this.key).toString();

    // make URL safe
    encrypted = encrypted
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');

    return encrypted;
  }

  decrypt(value: string): number {

    // revert URL safe characters
    let base64 = value
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const bytes = CryptoJS.AES.decrypt(base64, this.key);
    return parseInt(bytes.toString(CryptoJS.enc.Utf8));
  }
}